import theme from 'theme/theme';
import { Grid, Typography, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getAxios } from 'util/axios';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { URLS } from 'constants.js';

// SSR causes responsive to fail, so dynamic importing
const Slick = dynamic(import('components/Slick'), {
  ssr: false,
});

const useStyles = makeStyles(() => ({
  container: {
    padding: '90px 0 100px',
    backgroundColor: theme.palette.yellow,
    flexWrap: 'unset !important', // needed for carousel not to blow up on mobile?
    [theme.breakpoints.up('md')]: {
      flexWrap: 'wrap',
    },
  },
  imageContainer: {
    backgroundColor: theme.palette.yellow,
    height: '50vh',
    maxHeight: 700,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    backgroundSize: 'cover',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  titleTextGroup: {
    marginBottom: '30px',
  },
  titleText: {
    marginBottom: '20px',
    fontSize: '72px',
  },
  titleStoryTitle: {
    lineHeight: '.8',
    marginTop: '4rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '9rem',
    },
  },
  authorText: {
    fontSize: '0.875rem',
    fontWeight: 'bold',
    marginBottom: '4rem',
    textTransform: 'uppercase',
  },
  locationText: {
    padding: '6px 0',
    textTransform: 'uppercase',
  },
  locationDetectGroup: {
    display: 'block',
    [theme.breakpoints.up('md')]: {},
  },
  locationButton: {
    width: '100%',
    textTransform: 'none',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      width: '48%',
    },
  },
  inputField: {
    width: '100%',
    margin: '15px 0',
    border: '1px solid black',
    padding: '5px 10px',
    '& ::before': {
      display: 'none',
    },
    '& ::after': {
      display: 'none',
    },
    '&.last': {
      marginTop: 0,
    },
    [theme.breakpoints.up('md')]: {
      width: '48%',
      '&.last': {
        marginTop: '15px',
      },
    },
  },
  caption: {
    margin: '15px 0',
  },
  description: {
    display: 'block',
    marginBottom: '5em',
  },
  button: {
    color: theme.palette.yellow,
    backgroundColor: theme.palette.black,
    '&:hover': {
      color: theme.palette.black,
      backgroundColor: theme.palette.orange,
      transition: '0.3s linear',
    },
  },
  form: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  sendButton: {
    display: 'block',
    width: '100%',
    margin: '30px auto 40px',
    textTransform: 'none',
    [theme.breakpoints.up('md')]: {
      width: '40%',
    },
  },
  weRaisedSection: {
    textAlign: 'center',
    margin: '60px 0',
  },
  donationInfoSection: {
    display: 'flex',
    justifyContent: 'center',
    margin: '30px 0',
  },
  donationInfoText: {
    width: '200px',
    margin: '40px 0 0 10px',
  },
  hr: {
    backgroundColor: theme.palette.black,
    height: '1px',
    border: 'none',
  },
}));

const Stories = ({ stories }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        className={classes.container}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={10} md={8} justify="center">
          <Typography variant="h1" className={classes.titleText}>
            Stories
          </Typography>
          <Container maxWidth="md" disableGutters>
            <div style={{ maxWidth: '100%', width: '100%', display: 'block' }}>
              <Slick stories={stories} />
            </div>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

async function getProps() {
  const axios = getAxios();
  const response = await axios({
    url: URLS.stories,
    method: 'get',
  });
  const stories = response.data.results;
  return {
    props: {
      stories,
      styles: {
        color: theme.palette.yellow,
      },
    },
  };
}
export const getServerSideProps = getProps;

Stories.propTypes = {
  stories: PropTypes.array.isRequired,
};

export default Stories;
